// extracted by mini-css-extract-plugin
export default {"category_border":"CategoryNameTag_category_border__PG0Sn","category_name":"CategoryNameTag_category_name__L51H7"};